// Gürtelränge nach Punktzahl. Absteigend geprüft.
export const BELTS = [
  {
    key: "schwarz",
    label: "Schwarz",
    min: 780,
    color: "#111318",
    ring: "#3b0a12",
    textColor: "#ffffff",
    message:
      "Meisterhaft! Solche Konzentration begeistert unsere Lehrerinnen und Lehrer im Unterricht.",
  },
  {
    key: "braun",
    label: "Braun",
    min: 600,
    color: "#6b3f1e",
    ring: "#4a2a12",
    textColor: "#ffffff",
    message:
      "Wow, richtig schnell! Diesen Fokus lieben unsere Lehrerinnen und Lehrer.",
  },
  {
    key: "blau",
    label: "Blau",
    min: 440,
    color: "#2e6fb0",
    ring: "#1f4f80",
    textColor: "#ffffff",
    message:
      "Toll aufgepasst! Deine Konzentration passt super in unseren Unterricht.",
  },
  {
    key: "gruen",
    label: "Grün",
    min: 300,
    color: "#3fa34d",
    ring: "#2c7a37",
    textColor: "#ffffff",
    message:
      "Klasse Reaktion! Solche schnellen Reflexe üben wir im Unterricht.",
  },
  {
    key: "orange",
    label: "Orange",
    min: 180,
    color: "#e8862e",
    ring: "#b8641c",
    textColor: "#ffffff",
    message: "Starker Fokus! Genau so etwas üben wir im Unterricht.",
  },
  {
    key: "gelb",
    label: "Gelb",
    min: 80,
    color: "#f2c14e",
    ring: "#cc9a26",
    textColor: "#111318",
    message: "Schön gemacht! Deinen Fokus schärfen wir gemeinsam im Unterricht.",
  },
  {
    key: "weiss",
    label: "Weiß",
    min: 0,
    color: "#f5f0ea",
    ring: "#e0d6c8",
    textColor: "#111318",
    message: "Guter Anfang! Genau solche Übungen machen wir im Unterricht.",
  },
];

export function getBelt(score) {
  return BELTS.find((b) => score >= b.min) || BELTS[BELTS.length - 1];
}
